import {
  OTSTasksDTO,
  TaskFormattersDTO,
  OTSTaskStatusResult,
  TaskFormatterCreateRequest,
  UpdateOTSTasksStatusReqBody,
  UpdateOTSTasksStatusRespBody,
} from '@scale/shared/ots';
import apiFetch from '@scale/frontend-lib/api-fetch';
import { CreationType, DatapackSubcategory, Locale, TurnType } from '@scale/shared/ots/types';

export async function fetchTasks(taskIds: string[]) {
  const res = await apiFetch<OTSTasksDTO>(null, `corp-api/ots-utils-v2/tasks/lookup/tasks`, {
    method: 'POST',
    body: { taskIds },
  });
  return res;
}

// Unused
export async function fetchTaskFormatters(taskIds: string[]) {
  const res = await apiFetch<TaskFormattersDTO>(
    null,
    `corp-api/ots-utils-v2/formatters/lookup/tasks`,
    {
      method: 'POST',
      body: { taskIds },
    },
  );
  return res;
}

// Unused
export async function fetchTaskStatus(projectId: string, taskIds: string[]) {
  const res = await apiFetch<OTSTaskStatusResult>(
    null,
    `corp-api/ots-utils-v2/tasks/lookup/taskStatus`,
    {
      method: 'POST',
      body: { projectId, taskIds },
    },
  );
  return res;
}

// Unused
export async function addToTaskBank(
  projectId: string,
  datapackType: string,
  creationType: CreationType | undefined,
  datapackSubcategory: DatapackSubcategory | undefined,
  locale: Locale,
  turnType: TurnType,
  taskIds: string[],
  note: string,
  formatters: TaskFormatterCreateRequest[],
) {
  const res = await apiFetch(null, `corp-api/ots-utils-v2/tasks/addToTaskBank`, {
    method: 'POST',
    body: {
      projectId,
      datapackType,
      creationType,
      datapackSubcategory,
      locale,
      turnType,
      taskIds,
      note,
      formatters,
    },
  });
  return res;
}

export async function updateTasksStatus(reqBody: UpdateOTSTasksStatusReqBody) {
  const resp: UpdateOTSTasksStatusRespBody = await apiFetch(
    null,
    `corp-api/ots-utils-v2/tasks/status`,
    {
      method: 'PATCH',
      body: reqBody,
    },
  );
  return resp;
}

// Unused
export async function getProjectDataInfo(projectId: string) {
  const res = await apiFetch(null, `corp-api/ots-utils-v2/projects/${projectId}/data-info`);
  return res;
}

export async function getDataStreams() {
  const res = await apiFetch(null, `corp-api/ots-utils-v2/data-streams`);
  return res;
}
